import React, { createContext, useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import { notification } from 'antd';

// Kratka obavestenja posle akcija (uspeh/greska) - uvek u donjem desnom uglu.
// Jedna instanca za celu aplikaciju (ToastProvider u src/index.js), pa
// obavestenje prezivi i promenu stranice (npr. "Uspesna prijava!" posle logina).
// Izgled (sirina, razmaci, font) dolazi iz Notification tokena u antdTheme.js.
//
//   const toast = useToast();
//   toast.success('Sacuvano.');

const noop = () => {};
const ToastContext = createContext({
  success: noop,
  error: noop,
  info: noop,
  warning: noop,
});

export const ToastProvider = ({ children }) => {
  const [api, contextHolder] = notification.useNotification({
    placement: 'bottomRight',
    duration: 3,
    maxCount: 3,
    showProgress: true,
    pauseOnHover: true,
  });

  const toast = useMemo(
    () => ({
      success: (text) => api.success({ title: text }),
      error: (text) => api.error({ title: text }),
      info: (text) => api.info({ title: text }),
      warning: (text) => api.warning({ title: text }),
    }),
    [api]
  );

  return (
    <ToastContext.Provider value={toast}>
      {contextHolder}
      {children}
    </ToastContext.Provider>
  );
};

ToastProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default function useToast() {
  return useContext(ToastContext);
}
